import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAllSalesforceUsers } from '@api';

export const coreAllSalesforceUsersGetSlice = createGetAsyncSlice({
	httpSagaOptions: {
		cache: true
	},
	name: 'CoreAllSalesforceUsers',
	receive: true,
	request: false,
	requestHandler: getAllSalesforceUsers,
	retainDataOnRequest: true
});
